<style scoped>
    #bonus-excel-input{
        display: none;
    }
</style>
<template>
  <div>
    <div>
      <DatePicker
        type="year"
        placeholder="选择年份"
        style="width: 200px"
        @on-change="setYear"
      />
      <Button
        type="primary"
        @click="loadBonus"
      >
        加载数据
      </Button>
      <label
        class="ivu-btn ivu-btn-warning"
        for="bonus-excel-input"
      >
        <Icon type="android-upload" />
        导入数据
      </label>
    </div>

    <div class="line">
      <input
        id="bonus-excel-input"
        ref="importInput"
        type="file"
        @focus="importFocus"
        @change="importFile"
      >
      <div
        v-show="import_processing"
        class="line"
      >
        <Progress
          :percent="import_percent"
          status="active"
        />
      </div>
    </div>
    <div class="line">
      <Table
        border
        stripe
        width="500"
        :no-data-text="no_data_text"
        :loading="getting_bonus"
        :columns="bonus_columns"
        :data="bonuses"
        size="small"
      />
    </div>
  </div>
</template>
<script route="/bonus_reward/import">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/bonus_reward/import',
    /* router_info_end */
    data() {
      return {
        year: '',
        import_processing: false,
        import_percent: 0,
        getting_sms: false,
        sms_timeout: 0,
        getting_bonus: false,
        sms_code: '',
        bonuses: [],
        bonus_columns: [
          {
            title: '年份',
            align: 'center',
            width: 100,
            key: 'year'
          },
          {
            title: '工号',
            align: 'center',
            width: 100,
            key: 'uid',
            render: (h, params) => {
              const row = params.row;
              const customer = row.customer;
              if (customer) {
                return customer.uid
              } else {
                return '';
              }
            }
          },
          {
            title: '姓名',
            align: 'center',
            width: 150,
            key: 'account'
          },
          {
            title: '年终奖',
            align: 'center',
            width: 150,
            key: 'bonus'
          }
        ],
        no_data_text: '暂无数据'
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      setYear(year) {
        console.log(year);
        this.year = year;
      },
      resetInput() {
        this.$refs.importInput.value = '';
      },
      importFocus() {
        this.resetInput();
      },
      importFile() {
        if (!this.year) {
          this.$Modal.error({
            title: '提示',
            content: '请选择你要导入的年份.'
          });
          return;
        }
        const file_path = this.$refs.importInput.value;
        const path_arr = file_path.split('.');
        const extname = path_arr[path_arr.length - 1].toLowerCase();
        if (['xlsx'].indexOf(extname) === -1) {
          this.$Modal.warning({
            title: '提示',
            content: '请上传Excel文件(后缀名应为xlsx)'
          });
          return;
        }

        const file = this.$refs.importInput.files[0];
        const formData = new FormData();
        formData.append('datafile', file);
        formData.append('year', this.year);

        this.import_processing = true;
        Util.ajax({
          url: Util.api.import_bonus,
          method: 'post',
          data: formData,
          timeout: 120000,
          onUploadProgress: (e) => {
            const percent = e.loaded / e.total * 100;
            this.import_percent = percent < 0.1 ? 0.1 : percent;
          },
        }).then(function(response) {
          return response.data;
        }).then((data) => {
          this.import_processing = false;
          this.resetInput();
          console.log(data);
          if (data.code === 1) {
            this.loadBonus();
            this.$Modal.success({
              title: '提示',
              content: '导入成功!'
            });
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.import_processing = false;
          this.resetInput();
          this.$Message.error(`上传失败!: ${e}`);
        });
      },
      getSmsCode() {
        Util.ajax.post(Util.api.bonus_sms_admin_code, {
          customer_id: this.cur_customer.id,
          mobile: this.cur_customer.mobile
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.sms_timeout = 120;
            this.sms_timer = setInterval(() => {
              this.sms_timeout--;
              if (this.sms_timeout <= 0) {
                clearInterval(this.sms_timer);
              }
            }, 1000);
            this.$Message.success('发送短信成功!');
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      loadBonus() {
        console.log(this.year);
        if (!this.year) {
          this.$Message.error('请选择年份查看');
          return;
        }
        this.getting_bonus = true;
        Util.ajax.get(Util.api.get_bonus, {
          params: {
            year: this.year
          }
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.getting_bonus = false;
          if (data.code === 1) {
            this.bonuses = [];
            data.bonuses.forEach((bonus) => {
              this.bonuses.push(bonus);
            });
            if (this.bonuses.length === 0) {
              this.$Message.error('没有查询到数据');
            }
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.getting_bonus = false;
          this.$Modal.error({title: '提示', content: e.message});
        });
      }
    }
  }
</script>
